import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useAuthStore } from '@/store/auth'
import router from '@/router'
import { apiBase } from '@/utils/url'

const request = axios.create({
  baseURL: apiBase,
  timeout: 20000
})

request.interceptors.request.use((config) => {
  const auth = useAuthStore()
  if (auth.token) {
    config.headers.Authorization = 'Bearer ' + auth.token
  }
  return config
})

request.interceptors.response.use(
  (response) => {
    const res = response.data
    // 文件下载或非 envelope 直接放行
    if (res && typeof res === 'object' && 'code' in res) {
      if (res.code === 0) {
        return res
      }
      if (res.code === 401) {
        handleUnauthorized()
        return Promise.reject(new Error(res.msg || '未登录'))
      }
      if (res.code === 403) {
        ElMessage.error(res.msg || '无权限')
        return Promise.reject(new Error(res.msg || '无权限'))
      }
      ElMessage.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  (error) => {
    if (error.response) {
      const status = error.response.status
      if (status === 401) {
        handleUnauthorized()
      } else if (status === 403) {
        ElMessage.error('无权限访问')
      } else if (status === 404) {
        ElMessage.error('接口不存在')
      } else if (status >= 500) {
        ElMessage.error('服务器错误')
      } else if (error.response.data && error.response.data.msg) {
        ElMessage.error(error.response.data.msg)
      } else {
        ElMessage.error(error.message || '网络错误')
      }
    } else {
      ElMessage.error('网络连接失败')
    }
    return Promise.reject(error)
  }
)

function handleUnauthorized() {
  const auth = useAuthStore()
  auth.logoutLocal()
  ElMessage.error('登录已过期，请重新登录')
  router.push('/login')
}

export default request
